import React from "react";
import { useFormikContext } from "formik";
import PropTypes from "prop-types";
import cx from "classnames";
import { Button, ProcessingButton } from "@qgiv/core-donor";
import { useDispatch } from "react-redux";

const Submit = ({
    addButtonAriaLabel = "",
    addButtonLabel,
    addItemToRegistrationStoreCart = () => {},
    currentProductId,
    disabled = false,
    Field_Data_Id = "",
    indexOfItemToUpdate = -1,
    indexOfItemDuplicateToRemove = -1,
    isCms = false,
    isUpdateView = false,
    modalAccessedFromStoreList = false,
    setProductModalOpen = () => {},
    removeRegistrationStoreCartItem = () => {},
    updateButtonAriaLabel = "",
    updateButtonLabel,
    updateRegistrationStoreCart = () => {},
    updateCurrentStoreCartItemIndex = () => {},
}) => {
    const { values, isSubmitting } = useFormikContext();
    const dispatch = useDispatch();

    const addOrUpdateStoreItem = () => {
        if (indexOfItemToUpdate < 0 && !isUpdateView) {
            dispatch(
                addItemToRegistrationStoreCart({
                    ...values,
                    Product_Id: currentProductId,
                }),
            );
            dispatch(updateCurrentStoreCartItemIndex(-1));
        } else {
            dispatch(
                updateRegistrationStoreCart({
                    index: indexOfItemToUpdate,
                    productId: currentProductId,
                    fieldDataId: Field_Data_Id,
                    storeCart: {
                        ...values,
                        Product_Id: currentProductId,
                    },
                }),
            );
            // This will prevent a user from changing an item to match an existing item in the cart
            // Instead of allowing the duplicate, we are updating the one in the cart and removing
            // the change item.
            if (
                indexOfItemDuplicateToRemove !== null &&
                !modalAccessedFromStoreList
            ) {
                dispatch(
                    removeRegistrationStoreCartItem({
                        index: indexOfItemDuplicateToRemove,
                        productId: currentProductId,
                        fieldDataId: Field_Data_Id,
                    }),
                );
            }
        }

        dispatch(
            setProductModalOpen({
                productModalOpen: false,
                currentProductId: 0,
                modalAccessedFromStoreList: false,
            }),
        );
    };

    return isSubmitting ? (
        <ProcessingButton />
    ) : (
        <Button
            classes={cx(disabled && "-disabled")}
            btnStyle="primary"
            name="Add_Item_To_Cart"
            aria-label={
                isUpdateView ? updateButtonAriaLabel : addButtonAriaLabel
            }
            type="button"
            onClick={(e) => {
                e.preventDefault();
                // Prevent saving without a quantity or attributes selected or in cms
                if (isCms || disabled) {
                    return;
                }
                addOrUpdateStoreItem();
            }}
        >
            {isUpdateView ? updateButtonLabel : addButtonLabel}
        </Button>
    );
};
Submit.propTypes = {
    addButtonAriaLabel: PropTypes.string.isRequired,
    addButtonLabel: PropTypes.string.isRequired,
    addItemToRegistrationStoreCart: PropTypes.func.isRequired,
    currentProductId: PropTypes.number.isRequired,
    disabled: PropTypes.bool,
    Field_Data_Id: PropTypes.string,
    indexOfItemToUpdate: PropTypes.number,
    indexOfItemDuplicateToRemove: PropTypes.number,
    isCms: PropTypes.bool.isRequired,
    isUpdateView: PropTypes.bool.isRequired,
    modalAccessedFromStoreList: PropTypes.bool.isRequired,
    setProductModalOpen: PropTypes.func.isRequired,
    updateButtonAriaLabel: PropTypes.string.isRequired,
    updateButtonLabel: PropTypes.string.isRequired,
    updateCurrentStoreCartItemIndex: PropTypes.func.isRequired,
    updateRegistrationStoreCart: PropTypes.func.isRequired,
    removeRegistrationStoreCartItem: PropTypes.func.isRequired,
};

export default Submit;
